import '../About/About.css';
import Main from './Main/Main';
import Image from './Image/Image';

const About = () => {
  return (
    <section className="secondPage" id="aboutme">
      <Image />
      <Main />
    </section>
  );
};

export default About;
